module.exports = __webpack_public_path__ + "static/img/icon-wechat.4bcadc47.png";